import { render, staticRenderFns } from "./MyStore.vue?vue&type=template&id=64173b7a&scoped=true&"
import script from "./MyStore.vue?vue&type=script&lang=js&"
export * from "./MyStore.vue?vue&type=script&lang=js&"
import style0 from "./MyStore.vue?vue&type=style&index=0&id=64173b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64173b7a",
  null
  
)

export default component.exports